import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import getSchema from "../../lib/api/getSchema";
import notificationState from "../../states/notificationState";
import MomSysUdtOwnCompanyCreateButton from "../input/MomSysUdtOwnCompanyCreateButton";
import MomSysUdtOwnCompanyUpdateButton from "../input/MomSysUdtOwnCompanyUpdateButton";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

function MomSysOwnCompany ( props ) {
    const {id, masterGridSetting} = props;

    const [schema, setSchema] = useState();
    const [grid, setGrid] = useState();
    const [mstApi, setMstApi] = useState ();
    const [isEmpty, setIsEmpty] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect(()=> {
        let mounted = true;
        async function schemaSetting() {
            let schema = await getSchema("MomSysUdtCompany");
            if (mounted) {
                setSchema(schema);
            }
        }

        schemaSetting();

        return (() => {
            mounted = false;
        });
    },[]);

    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        masterGridSetting(grid.selectedItems[0]);
                    } else {
                        masterGridSetting([]);
                    };
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        masterGridSetting(grid.selectedItems[0]);
                    } else {
                        masterGridSetting([]);
                    };
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);

    const onSuccess = ( msg ) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onFailure = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    }

    const onLoadData = (data) => {
        setIsEmpty(data.length < 1 ? true : false)
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    const onApiInitialized = ( api ) => {
        setMstApi ( api );
    };

    return (
        <BasicCrudScreenType 
            id={id}
            table="MomSysUdtCompany" 
            view="MomSysVwOwnCompany" 
            onLoadData={onLoadData}
            noCreate
            noEdit
            noExcel
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onAppendButtonAtFirst = {
                () => (
                    <>
                        <BasicCrudScreenActionItemLayout>
                            <MomSysUdtOwnCompanyCreateButton
                                id = "MomSysOwnCreateCompany"
                                grid = {grid}
                                schema = {schema}
                                refresh = {mstApi}
                                onSuccess = {onSuccess}
                                onFailure = {onFailure}
                            />
                        </BasicCrudScreenActionItemLayout>
                        
                        <BasicCrudScreenActionItemLayout>
                            <MomSysUdtOwnCompanyUpdateButton
                                id = "MomSysOwnUpdateCompany"
                                grid = {grid}
                                schema = {schema}
                                refresh = {mstApi}
                                onSuccess = {onSuccess}
                                onFailure = {onFailure}
                                disabled={isEmpty ? true : false}
                            />
                        </BasicCrudScreenActionItemLayout>
                    </>
                )
            }    
        />
    )
}

export default MomSysOwnCompany;
